import { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";

let cache = null;

export const usePopular = () => {
  const [slugs, setSlugs] = useState([]);
  useEffect(() => {
    cache = cache || api.get("/popular").then((r) => r.data.slugs).catch(() => []);
    cache.then(setSlugs);
  }, []);
  return slugs;
};

export const PopularBadge = ({ slug, className = "" }) => {
  const slugs = usePopular();
  const { t } = useLang();
  if (!slugs.includes(slug)) return null;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full bg-[#C2410C] px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-white shadow-md ${className}`} data-testid={`popular-badge-${slug}`}>
      <Flame className="h-3.5 w-3.5" /> {t("badge.popular")}
    </span>
  );
};
